import { getLinks, getStoryBySlug } from "@cinch-nx/data-storyblok";
import { traceFunction, tagError, setTag } from "@core/datadog-server";
async function getStaticPropsFn({ preview =false  }) {
    try {
        var ref, ref1;
        setTag("page.name", "modern-slavery-hub");
        setTag("page.rendered", "ISR");
        setTag("page.revalidate-in", "60s");
        setTag("page.params", JSON.stringify({
            preview
        }, null, 2));
        const links = await getLinks("policies/modern-slavery-statement/statements");
        const story = await getStoryBySlug("policies/modern-slavery-statement/index");
        const actualLinks = Object.values(links).filter((link)=>link.published === true);
        if (!story) {
            throw new Error("No story found within modern slavery");
        }
        const HeroProps = story === null || story === void 0 ? void 0 : (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.hero) === null || ref1 === void 0 ? void 0 : ref1[0];
        setTag("page.response-code", 200);
        return {
            props: {
                preview,
                links: actualLinks,
                layoutProps: {
                    showBorderRadius: false,
                    heroProps: HeroProps
                }
            },
            revalidate: 60
        };
    } catch (error) {
        if (error instanceof Error || typeof error === "string") {
            tagError(error);
        }
        setTag("page.response-code", 404);
        return {
            notFound: true,
            props: {
                links: [],
                layoutProps: {
                    showBorderRadius: false,
                    heroProps: []
                }
            },
            revalidate: 60
        };
    }
}
export const getStaticProps = traceFunction("modernSlaveryHub.getStaticProps", getStaticPropsFn);
